import { z } from "zod";
import { ActionBundleSchema } from "./actions.js";
export const CreateActionBundleRequestSchema = ActionBundleSchema.omit({
    contentHash: true,
    tenantId: true,
    createdBy: true,
}).extend({
    status: z.literal("draft"),
});
export const ApiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        requestId: z.string().optional(),
    }),
});
//# sourceMappingURL=api.js.map